import { ANNEE_CALENDRIER_STATIQUE, VACANCES_REUNION_STATIQUE, PERIODES_REUNION_STATIQUE } from './calendrierReunion';

const zones = ['Corse','Guadeloupe','Guyane','Martinique','Nouvelle Calédonie','Polynésie','Réunion','Saint Pierre et Miquelon','Wallis et Futuna','Zone A','Zone B','Zone C']
const zone = "Réunion"

// Repli statique (calendrierReunion.js) : servi UNIQUEMENT si l'année
// scolaire courante correspond au calendrier embarqué — un statique périmé
// produirait des dates fausses en silence, on préfère alors l'erreur visible.
const calendrierStatique = () => {
  if (getCurrentSchoolYear() !== ANNEE_CALENDRIER_STATIQUE) return null;
  return { vacances: VACANCES_REUNION_STATIQUE, periode: PERIODES_REUNION_STATIQUE };
};
function getCurrentSchoolYear(date = new Date()) {
  const currentYear = date.getFullYear();
  // Le 1er août de l'année en cours (en JavaScript, août correspond à 7 car janvier = 0)
  const augustFirst = new Date(currentYear, 7, 1);
  
  // Si la date est avant le 1er août, on est toujours dans l'année scolaire qui a commencé l'année précédente
  if (date < augustFirst) {
    return `${currentYear - 1}-${currentYear}`;
  }
  
  // Sinon, on est dans l'année scolaire qui commence cette année et se termine l'année suivante
  return `${currentYear}-${currentYear + 1}`;
}

function getPreviousSchoolYear() {
  // Par exemple, getCurrentSchoolYear() retourne "2024-2025"
  const currentSchoolYear = getCurrentSchoolYear();
  const [startYear, endYear] = currentSchoolYear.split("-");
  // L'année de début de l'année scolaire précédente est l'année de début actuelle moins 1
  const previousStartYear = parseInt(startYear, 10) - 1;
  const previousEndYear = parseInt(startYear, 10);
  return `${previousStartYear}-${previousEndYear}`;
}

export const fetchSchoolHolidays = async () => {
      // Construire la partie de la requête pour les années scolaires
    const academicQuery = ` (annee_scolaire="${getCurrentSchoolYear()}" OR annee_scolaire="${getPreviousSchoolYear()}") `;

    // Encoder la query et la zone pour s'assurer que les espaces et accents soient correctement transformés en %XX
    const encodedQuery = encodeURIComponent(academicQuery);
    const encodedZone = encodeURIComponent(`"${zone}"`);

    // Construire l'URL complète avec la partie encodée pour la query et la zone
    const url = `https://data.education.gouv.fr/api/explore/v2.1/catalog/datasets/fr-en-calendrier-scolaire/records?where=${encodedQuery}&group_by=start_date%2Cend_date%2Cdescription%2Cpopulation%2Czones%2Cannee_scolaire&limit=100&refine=zones:${encodedZone}`;

    
    try {
      const response = await fetch(
        url  );
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des vacances scolaires");
      }
      const data = await response.json();
     
     
     // Transformation des données : renomme description -> title, start_date -> start, end_date -> end
     const vacances = data.results
     .filter(item => item.description && item.description.includes("Vacances"))
     .map(item => {
       const { description, start_date, end_date, ...others } = item;
       const key = `${description}-${start_date}-${end_date}`; 
       return {
         ...others,
         title: description,
         start: new Date(start_date).toISOString().split("T")[0], // Format "YYYY-MM-DD"
         end: new Date(end_date).toISOString().split("T")[0],
         display: "background",
         backgroundColor: "#b0b0b0"
       };
     })

     const uniqueVacances = [];
     const keys = new Set();
     vacances.forEach(vac => {
       const key = `${vac.title}-${vac.annee_scolaire}`;
       if (!keys.has(key)) {
         keys.add(key);
         uniqueVacances.push(vac);
       }
     });

    // Tri des vacances par date de début
    const sortedVacances = [...uniqueVacances].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

   

    // Séparation par année scolaire
    const vacancesLastYear = sortedVacances.filter(
      item => item.annee_scolaire === getPreviousSchoolYear()
    );
    const vacancesCurrentYear = sortedVacances.filter(
      item => item.annee_scolaire === getCurrentSchoolYear()
    );

    let filteredVacances = [];

    // Pour 2023-2024, on ne garde que le dernier élément (celui qui se termine le plus tard)
    if (vacancesLastYear.length > 0) {
      filteredVacances.push(vacancesLastYear[vacancesLastYear.length - 1]);
    }

    // Pour 2024-2025, on garde tous les éléments sauf le dernier (s'il y en a plusieurs)
    if (vacancesCurrentYear.length > 1) {
      filteredVacances = filteredVacances.concat(vacancesCurrentYear);
    }
    // Si il n'y a qu'un seul élément pour 2024-2025, on ne le prend pas (selon ta demande)

    // On re-tri les vacances filtrées par date de début
    filteredVacances.sort((a, b) => new Date(a.start) - new Date(b.start));
   

    // Calcul des périodes entre les vacances filtrées :
    // Pour chaque vacation à partir de la 2ème, la période correspond à l'intervalle entre la date de fin de la vacation précédente et la date de début de la vacation actuelle.
    const periode = filteredVacances.reduce((acc, curr, index, arr) => {
      if (index > 0) {
        const previous = arr[index - 1];
        acc.push({
          type_periode: "Periode ",
          numero : index,
          date_debut: previous.end,
          date_fin: curr.start
        });
      }
      return acc;
    }, []);


  
    // API muette sur l'année en cours (constaté : la Réunion est publiée
    // APRÈS la métropole) → une seule vacance filtrée → zéro période.
    // Repli sur le calendrier statique embarqué s'il couvre l'année.
    if (periode.length === 0) {
      const statique = calendrierStatique();
      if (statique) return statique;
    }

    // Retourne l'ensemble des vacances triées et les périodes calculées
    return { vacances: sortedVacances, periode };
  } catch (error) {
    console.error("Erreur :", error);
    // Échec réseau/API : même repli statique si l'année est couverte.
    const statique = calendrierStatique();
    if (statique) return statique;
    // `erreur: true` : champ ADDITIF (les consommateurs qui destructurent
    // {vacances, periode} ne voient rien changer) : permet au modal d'import
    // d'afficher un bandeau + Réessayer au lieu d'échouer en silence.
    return { vacances: [], periode: [], erreur: true };
  }
};


export const vacances = [ 
{ title: "Rentrée des enseignants", start: "2024-08-16", end: "2024-08-16", display: 'background', backgroundColor: '#b0b0b0' },
{ title: "Rentrée des élèves", start: "2024-08-19", end: "2024-08-19", display: 'background', backgroundColor: '#b0b0b0' },
{ title: "Vacances après 1ère période", start: "2024-10-12", end: "2024-10-28", display: 'background', backgroundColor: '#b0b0b0' },
{ title: "Vacances été austral", start: "2024-12-19", end: "2025-01-21", display: 'background', backgroundColor: '#b0b0b0' },
{ title: "Vacances après 3e période", start: "2025-03-01", end: "2025-03-17", display: 'background', backgroundColor: '#b0b0b0' },
{ title: "Vacances après 4e période", start: "2025-05-03", end: "2025-05-19", display: 'background', backgroundColor: '#b0b0b0' },
{ title: "Vacances d'hiver austral", start: "2025-07-05", end: "2025-08-19", display: 'background', backgroundColor: '#b0b0b0',editable: false, overlap: false }
];

const generatePeriods = (vacances) => {
    // Trier les vacances par date de début
    const sortedVacances = [...vacances].sort((a, b) => new Date(a.start) - new Date(b.start));

    let periods = [];
    let periodNumber = 1;

    // Trouver la "Rentrée des élèves"
    const rentreeEleves = sortedVacances.find(v => v.title === "Rentrée des élèves");

    if (!rentreeEleves) {
        console.error("❌ Pas de rentrée des élèves trouvée !");
        return vacances; // Retourne la liste originale si pas trouvée
    }

    let lastEnd = rentreeEleves.end; // Commence après la rentrée des élèves

    sortedVacances.forEach((vacance) => {
        // On commence UNIQUEMENT après la rentrée des élèves
        if (new Date(lastEnd) >= new Date(rentreeEleves.end) && new Date(vacance.start) > new Date(lastEnd)) {
            // Ajoute une période entre la dernière date et la prochaine période de vacances
            periods.push({
                title: `Période ${periodNumber}`,
                start: lastEnd,
                end: vacance.start,
                display: 'background',
                backgroundColor: '#ffcc99', // Couleur des périodes scolaires
            });
            periodNumber++;
        }
        lastEnd = vacance.end; // Met à jour la dernière date de fin
    });

    return [...periods].sort((a, b) => new Date(a.start) - new Date(b.start));
};


// Générer les périodes scolaires et les ajouter aux vacances
export const vacancesAvecPeriodes = generatePeriods(vacances);